<template>
    <div>
        <!--    <img src="./print.svg" alt="" style="width: 100%;">-->
        <section>
            <div class="searchBox">
				<div>
					<el-input
					    class="searchInput"
					    size="small"
					    v-model="productName"
					    @keyup.native="changeProductInfo"
					    placeholder="输入关键字"
					    suffix-icon="el-icon-search">
					</el-input>
				</div>
            </div>
            <div v-if="tableData.length==0" style="text-align:center;margin-bottom:20px" >
                <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
            </div>
            <el-row :gutter="30" style="display: flex;flex-wrap: wrap;width:73%" v-if="tableData.length>0" class="imgListBox" >
                <el-col :span="8" v-for="(items, index) in tableData"
                        @click.native="goToDetail(items.id)"
                        :key="index">
                    <el-card
                            class="box-card"
                            shadow="hover"
                            :body-style="{ padding: '0px' }"
                    >
                         <div class="image">
                            <img v-if="items.mainPhotoUrl !=null" style="width: 100%;height: 200px;" :src="items.mainPhotoUrl" alt=""/>
                        </div>
                        <div style="padding: 15px">
                            <h4 class="mpTitle">{{ items.title }}</h4>
                            <p class="mpComp" :title="items.company">
                                {{ items.company }}
                            </p>
                            <dl class="mpDetail clearfix">
                                <dt>服务行业：</dt>
                                <dd>{{items.oneLabel| ellipsisService}}</dd>
                            </dl>
                            <p class="mpPrice">¥{{ items.money }} <span>议价</span></p>
                            <div class="mpFooter">
                                <span>
                                    <i class="el-icon-star-off" style="margin-right: 8px"></i>
                                    收藏量：{{ items.collectNum }}
                                </span>
                                <span>
                                    <i class="el-icon-shopping-cart-2" style="margin-right: 8px"></i>
                                    交易量：{{ items.orderNum }}
                                </span>
                            </div>
                        </div>
                        <!-- <div class="sdmessagesbotMes">
                            <div class="flex brandBox">
                                <p class="brand">{{ items.oneLabel }}</p>
                                <h4>{{ items.title }}</h4>
                            </div>
                            <span>¥{{ items.money }}</span>
                        </div> -->
                    </el-card>
                </el-col>
            </el-row>
            <div style="text-align: right">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total" class="pagination">
                </el-pagination>
            </div>
        </section>
    </div>
</template>

<script>
import {getShopList, serviceEnterprisePage, webStoreTree} from '../../utils/interface';

    export default {
        //   服务展示
        name: "printShopResults",
        components: {},
        data() {
            return {
                uuid: '',
                storeId: '',
                current: 1,
                total: 0,
                // pageSize: 6,
                pageSize: 9,
                productName: '',
                tableData: [],
                storeTypeCode: '',
                storeTypeOptions:[],
                storeFirstTypeUuid:'',
                storeSecondTypeUuid:'',
                storeThirdTypeUuid:'',
                props: {
                    value: 'value',
                    label: 'label',
                    checkStrictly: true
                },
            };
        },
        created() {
        },
        methods: {
            init(enterpriseUuid){
                this.enterpriseUuid = enterpriseUuid;
                this.getShopList();
            },
            changeProductInfo() {
                this.current = 1;
                this.getShopList();
            },
            getShopList() {
                let params = {
                  title: this.productName,
                  currentPage: this.current,
                    pageSize: this.pageSize,
                  enterpriseUuid: this.enterpriseUuid,
                  audit:'1',
                };
              serviceEnterprisePage(params).then((res) => {
                    this.tableData = res.records;
                    this.total = Number(res.total);
                });
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
				window.scrollTo(0,0);
                this.getShopList()
            },
            goToDetail(uuid){
              /*let routeData = this.$router.resolve({
                name: "serviceDetails",
                params: { uuid: uuid },
              });*/
              let routeData = this.$router.resolve({
                path: `/serviceDetails`,
                query: { uuid:uuid }
              });
              window.open(routeData.href, "_blank");
            },
            },
    };
</script>

<style scoped lang="less">
    .container {
        width: 1200px;
        margin: 0 auto;
    }

    .leftCont {
        margin-top: 30px;

        .leftCard {
            margin-bottom: 30px;
            border: none;

            /deep/ .el-card__header {
                color: #099;
                background-color: #F3F3F3;
                font-size: 18px;
                padding: 12px 20px;
            }

            /deep/ .el-card__body {
                background-color: #fbfbfb;
            }
        }

        .servInfo h3 {
            font-size: 16px;
            font-weight: normal;
            margin-bottom: 15px;
        }

        .servInfo .eval li {
            font-size: 14px;
            margin-bottom: 10px;
            display: flex;
        }

        .servInfo .eval li span {
            margin-right: 30px;
        }

        .servInfo .contact {
            margin-top: 30px;
            margin-bottom: -10px;
            font-size: 12px;
        }

        .servInfo .contact i {
            margin-right: 5px;
        }

        .servInfo .contact p {
            font-size: 14px;
            margin-bottom: 10px;
        }
    }

    .printTitle {
        font-size: 24px;
        font-weight: normal;
        color: #099;
        margin-top: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #e3e3e3;
        padding-bottom: 10px;

        span.tit {
            padding-bottom: 10px;
            border-bottom: 1px solid #099;
        }

        span.more {
            font-size: 16px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
        }
    }

    .hotSell {
        margin-bottom: -30px;

        li {
            margin-bottom: 30px;
        }

        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }

        .topServBoxInfo p {
            font-size: 12px;
            color: #aaa;
        }
    }

    .relateServ {
        margin-bottom: -30px;

        li {
            margin-bottom: 30px;
        }

        .topServBoxInfo h3 {
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: normal;
        }
    }

    .topServBox {
        background-color: #fff;
        height: 200px;
        border-radius: 8px;
        box-shadow: 0 1px 5px #eaeaea;
        margin-top: -100px;
        padding: 30px;
        box-sizing: border-box;

        .topServBoxInfo h3 {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: normal;
        }

        .topServBoxInfo p {
            font-size: 12px;
            color: #585858;
        }

        /deep/ .el-menu.el-menu--horizontal {
            border-color: transparent;
        }

        /deep/ .el-menu--horizontal > .el-menu-item.is-active {
            border: none !important;
            background-color: #F3F8FF;
            border-radius: 5px;
        }

        /deep/ .el-menu--horizontal > .el-menu-item {
            height: 30px;
            line-height: 26px;
        }
    }

    .topServBoxNum {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;

        p:first-child {
            font-size: 16px;
        }

        p:last-child {
            font-size: 12px;
            color: #585858;
        }
    }

    .menu-sub {
        margin-top: 35px;
        font-size: 16px;
    }

    .box-card {
        margin-bottom: 30px;
        position: relative;

        .image {
            width: 100%;
            height: 150px;
            display: block;
        }
    }

    .searchBox {
        background-color: #FAFCFF;
        height: 50px;
        line-height: 50px;
        margin: 30px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 20px;

        .searchInput /deep/ .el-input__inner {
            border-radius: 30px;
        }

        /deep/ .el-form-item {
            margin-bottom: 0;
        }

        /deep/ .el-form-item__label {
            line-height: inherit;
        }

        /deep/ .el-form-item__content {
            line-height: inherit;
        }

		.el-cascader /deep/ .el-input__inner{
			height: 32px;
			line-height: 32px;
		}
    }
    // .imgListBox{
    //   /deep/  .el-col-8{
    //       width: 25%;
    //   }
    // }
    .mpBox {
        display: flex;
        align-items: center;
    }

    .mpCheck {
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .mpTitle {
        font-size: 14px;
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .mpComp {
        margin-top: 10px;
        font-size: 13px;
        color: #000000;
    }

    .mpPrice {
        margin: 10px 0;
        font-size: 13px;
        color: #DA251D;

        span {
            color: #000;
            margin-left: 10px;
        }
    }

    .mpDetail {
        margin-top: 10px;

        dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: normal;
            line-height: 22px !important;
        }

        dd {
            font-size: 13px;
            line-height: 22px !important;
            margin-left: 70px;
            margin-bottom: 6px;
            color: #808080;
        }
    }

    .mpFooter-v1 {
        text-align: center;
        font-size: 14px;
        background: #F1F5FE;
        border: 1px solid #EBEEF5;
        margin: -10px -21px -21px;
        height: 50px;
        line-height: 50px;
    }

    .mpFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        border-top: 1px solid #E3E3E3;
        margin: 0 0 -15px;
        position: relative;

        span {
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            line-height: 50px;
        }

        span a {
            font-size: 12px;
            color: #808080;
        }

        span a:hover {
            color: rgba(21, 126, 251, 0.80);
        }

        :after {
            position: absolute;
            content: '';
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
        }
    }

    .printBox {
        /deep/ .el-input--suffix .el-input__inner {
            padding: 0 15px;
        }
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    a {
        color: #099;
    }

    a:hover {
        color: rgba(21, 126, 251, 0.80);
    }

    .mpTime {
        font-size: 12px;
        color: #aaa;
        margin-top: 6px;
    }
    .box-card {
        margin-bottom: 30px;
        /*height: 400px;*/
        position: relative;
        .image {
            width: 100%;
            height: 200px;
            display: block;
        }
        /deep/.el-card__body{
            padding: 20px 10px 15px 15px;
        }
    }

    .dmessagesBottombox {
        width: 216px;
        margin-bottom: 13px;
        // margin-bottom: 25px;
        &:hover .sdmessagesbotMes{
            background: #79cdcd;
            color: #fff;
            span {
                color: #fff;
            }
        }

        img {
            width: 100%;
            height: 138px;
            background: #efefef;
            display: block;
        }

        .sdmessagesbotMes {
            cursor: pointer;
            width: 100%;
            height: 62px;
            color: #0f1826;
            text-align: center;
            background: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .brandBox {
                align-items: center;
                justify-content: center;
                width: 210px;
            }
            h4 {
                //   width: 80%;
                  font-size: 16px;
                  margin-bottom: 6px;
                  font-weight: normal;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
            }

            p {
                font-size: 10px;
                font-weight: 400;
                 margin-bottom: 6px;
            }

            span {
                font-size: 12px;
                font-weight: bold;
                color: #ff0000;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/serviceList.vue